import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	Row,
	Card,
	CardBody,
	CardText,
	Badge,
	Table,
	BreadcrumbItem,
	Media,
	Spinner,
} from "reactstrap";
import propertyImage from "assets/images/property_type.png";
import sizeImage from "assets/images/size.png";
import whatsapp from "assets/images/whatsapp.png";
import bedImage from "assets/images/bed.png";
import bathImage from "assets/images/bathroom.png";
import paintImage from "assets/images/paint-bucket.png";
import dollarImage from "assets/images/dollar.png";
import kitchen from "assets/images/kitchen.png";
import swimming from "assets/images/swimming_bool.png";
import shutters from "assets/images/swimming_bool.png";
import furniture from "assets/images/furniture.png";
import pergolas from "assets/images/pergolas.png";
import amenities from "assets/images/amenities.png";
import realImage from "assets/images/real_state.png";
import { MetaTags } from "react-meta-tags";
import { Link } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import Slider from "./Slider";
import ResaleService from "services/Website/ResaleService";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import MyMap from "components/Common/google-map/MyMap";
import { useSelector, useDispatch } from "react-redux";
import { addInterest } from "store/Auth/actions";
import InterestServices from "services/Website/InterestServices";
import "./styles.scss";
import { toast } from "react-toastify";
import "assets/scss/website/app.scss";
import "react-rangeslider/lib/index.css";
import compoundImg from "assets/images/bg.png";
import { useTranslation } from "react-i18next";
import CallModal from "components/Website/Cards/CallModal";
import Skeleton from "components/Website/Skeleton";
import classnames from "classnames";
import http from "services/HttpService";
import MessageModal from "components/Website/Cards/MessageModal";
import CheckAvailabilityModal from "components/Website/Cards/CheckAvailabilityModal";
import ReactWhatsapp from "react-whatsapp";
import AlbumModal from "../PropertyDetails/Modal/AlbumModal";

const ResaleDetailsPage = (props) => {
	const { id } = props.match.params;
	const { t } = useTranslation();
	const [resaleDetails, setResaleDetails] = useState({});
	const [items, setItems] = useState([]);
	const [albumModal, setAlbumModal] = useState(false);
	const [mapRender, setMapRender] = useState(0);
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const dispatch = useDispatch();
	const interestServices = new InterestServices();
	const resaleService = new ResaleService();
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const [interestLoading, setInterestLoading] = useState(false);
	const [activeOwnerPay, setActiveOwnerPay] = useState("1");
	const [DetailsLoading, setDetailsLoading] = useState(true);
	const [checkAvailabilityModal, setCheckAvailabilityModal] = useState(false);
	const [checkAvailability, setCheckAvailability] = useState(0);
	const videoResponsive = {
		superLargeDesktop: {
			breakpoint: { max: 4000, min: 3000 },
			items: 1,
			slidesToSlide: 1,
		},
		desktopLg: {
			breakpoint: { max: 3000, min: 1300 },
			items: 1,
			slidesToSlide: 1,
		},
		desktop: {
			breakpoint: { max: 1300, min: 1100 },
			items: 1,
			slidesToSlide: 1,
		},
		tablet: {
			breakpoint: { max: 1100, min: 600 },
			items: 1,
			slidesToSlide: 1,
		},
		mobile: {
			breakpoint: { max: 600, min: 0 },
			items: 1,
			slidesToSlide: 1,
		},
	};
	useEffect(() => {
		http.setLang();
		resaleService.find(id).then((response) => {
			if (response && response.status === SuccessOk) {
				setResaleDetails(response.data);
				setDetailsLoading(false);
				setCheckAvailability(response.data.check_availability);
			} else {
				if (response == "Resale Not Found !") {
					toast.error("Resale Not Found");
					props.history.push("/");
				}
			}
		});
	}, [AuthData?.currency?.currency_code]);

	useEffect(() => {
		window.scrollTo(0, 0);
		if (resaleDetails.location?.lat && resaleDetails.location?.lang) {
			setMapRender(mapRender + 1);
		}
	}, [resaleDetails]);

	useEffect(() => {
		const data = resaleDetails?.images?.map((img, index) => {
			return {
				src: img.path,
				altText: `Slide ${index + 1}`,
				caption: `Slide ${index + 1}`,
			};
		});
		setItems(data);
	}, [resaleDetails]);

	const updateLocationPositions = (lat, lng) => {
		setResaleDetails({ ...resaleDetails, ...{ lat, lng } });
	};

	const isInterested = () => {
		const id = parseInt(resaleDetails?.id);
		return AuthData.interestsResales.includes(id);
	};

	const interestHandler = (id) => {
		const data = { resale_id: id };
		setInterestLoading(true);
		if (!isInterested()) {
			interestServices.createInterest(data).then((response) => {
				if (response && response.status === SuccessCreated) {
					toast.success(`${"Resale Added to Your Interests Successfully"}`);
					dispatch(
						addInterest({
							interestsResales: [...AuthData.interestsResales, id],
						})
					);
					setInterestLoading(false);
				}
			});
		} else {
			interestServices.deleteInterest(data).then((response) => {
				if (response && response.status === SuccessOk) {
					toast.success(`${t("Resale removed from Your interests")}`);
					const updatedInteres = AuthData.interestsResales.filter(
						(item) => item !== resaleDetails.id
					);
					dispatch(addInterest({ interestsResales: [...updatedInteres] }));
					setInterestLoading(false);
				}
			});
		}
	};

	const currentYear = new Date().getFullYear();

	if (DetailsLoading) {
		return <Skeleton.ResaleDetails history={props.history} />;
	}

	return (
		<div className="websitPages pt-10rem">
			<MetaTags>
				<title>{t("resale details")}</title>
			</MetaTags>
			<div>
				<Container fluid className="px-lg-5 px-3 pb-5">
					{/* <ol className="breadcrumb ps-0 mb-2">
						<BreadcrumbItem>
							<Link to="/">{t("home")}</Link>
						</BreadcrumbItem>
						<BreadcrumbItem style={{ cursor: "pointer" }}>
							<Link to={`/resales`}>{t("results")}</Link>
						</BreadcrumbItem>
						<BreadcrumbItem active>{t("Property Details")}</BreadcrumbItem>
					</ol> */}

					<p
						className="page-title"
						dangerouslySetInnerHTML={{
							__html: t("Resale Details"),
						}}></p>

					{/* {items?.length >= 3 && (
						<Row>
							<Col md={7}>
								<Slider items={items} />
							</Col>
							<Col md={5}>
								{resaleDetails?.images?.map((img, index) => {
									if (index < 2) {
										return (
											<img
												key={index}
												src={img.path}
												className={`samHeight d-block w-auto m-auto midImage ${
													index === 1 ? "mt-3" : ""
												}`}
												style={{ maxWidth: "100%" }}
											/>
										);
									}
								})}
							</Col>
						</Row>
					)}
					{items?.length === 2 && (
						<Row>
							{resaleDetails?.images?.map((img, index) => {
								if (index < 2) {
									return (
										<Col md={6} key={index}>
											<img
												src={img.path}
												className="midImage my-2"
												style={{ height: "500px" }}
											/>
										</Col>
									);
								}
							})}
						</Row>
					)}
					{items?.length === 1 && (
						<Row>
							{resaleDetails?.images?.map((img, index) => {
								if (index == 0) {
									return (
										<Col md={12} key={index}>
											<img src={img.path} className="img-responsive2" />
										</Col>
									);
								}
							})}
						</Row>
					)} */}

					<Row className="property-images">
						{items && items?.length >= 1 && (
							<Col md={3}>
								<img
									src={items[0]?.src}
									alt={items[0]?.altText}
									onClick={() => setAlbumModal(true)}
									className="w-100 first-col"
								/>
							</Col>
						)}
						{items && items?.length >= 2 && (
							<Col md={3}>
								{items?.length >= 2 && (
									<img
										src={items[1]?.src}
										alt={items[1]?.altText}
										onClick={() => setAlbumModal(true)}
										className="w-100 second-col first"
									/>
								)}
								{items?.length >= 3 && (
									<img
										src={items[2]?.src}
										alt={items[2]?.altText}
										onClick={() => setAlbumModal(true)}
										className="w-100 second-col second"
									/>
								)}
							</Col>
						)}
						{items && items?.length >= 4 && (
							<Col md={3}>
								<img
									src={items[3]?.src}
									alt={items[3]?.altText}
									onClick={() => setAlbumModal(true)}
									className="w-100 first-col"
								/>
							</Col>
						)}
						{items && items?.length >= 5 && (
							<Col md={3}>
								{items?.length >= 4 && (
									<img
										src={items[4]?.src}
										alt={items[4]?.altText}
										onClick={() => setAlbumModal(true)}
										className="w-100 second-col second"
									/>
								)}
								{items?.length >= 6 && (
									<div className="last" onClick={() => setAlbumModal(true)}>
										<img
											src={items[5]?.src}
											alt={items[5]?.altText}
											className="w-100 second-col"
										/>
									</div>
								)}
							</Col>
						)}
						{albumModal && (
							<AlbumModal
								albumModal={albumModal}
								setAlbumModal={setAlbumModal}
								images={items}
							/>
						)}
						{resaleDetails && resaleDetails?.images.length === 0 && (
							<Col md={12}>
								<img src={compoundImg} className="img-responsive2" />
							</Col>
						)}
					</Row>

					<Row className="pt-4">
						<Col lg={9} md={8}>
							<p className="text-color m-0 font-size-32 fw-bold">
								{resaleDetails?.name[`${AuthData.lang}`]
									? resaleDetails?.name[`${AuthData.lang}`]
									: resaleDetails?.name?.en}
							</p>
							{/* <CardText tag="h3">
								<Badge className="custom-badge font-size-12">
									{resaleDetails?.unit_type?.name[`${AuthData.lang}`]}
								</Badge>
							</CardText> */}
							<p className="text-color mb-0 font-size-16">
								{resaleDetails?.location?.street_address[`${AuthData.lang}`]} ,
								{resaleDetails?.area?.name} ,
								{resaleDetails?.location?.City[`${AuthData.lang}`]}
							</p>
							<CardText tag="h3" className="fw-bold text-primary pt-3">
								{toCurrency(resaleDetails?.payment_plan?.total_price)}{" "}
								{currency?.currency_code}{" "}
								<span className="text-color font-size-14 font-weight-normal">
									{resaleDetails?.payment_plan?.payment_method === "Cash"
										? t("only cash")
										: resaleDetails?.payment_plan?.payment_method ===
										  "Owner Installment"
										? t("up to owner installment", {
												num:
													parseInt(
														resaleDetails?.payment_plan?.owner_installment
															.until_year
													) - currentYear,
										  })
										: t("up to installment resale", {
												num: resaleDetails?.payment_plan?.years[0].years,
										  })}
								</span>
							</CardText>
							<CardText className="font-size-16">
								<p className="text-color mb-0 pt-1"> {t("Deposit")}</p>
								<span className="fw-bold text-color">
									{toCurrency(resaleDetails?.payment_plan?.depost)}{" "}
									{currency?.currency_code}
								</span>
							</CardText>
						</Col>
						<Col lg={3} md={4}>
							<div>
								<div className="w-100">
									<Link
										to={`/resale-view/${id}/details`}
										style={{
											background: "var(--primary-color)",
											borderColor: "var(--primary-color)",
										}}
										className="w-100 br-25 btn btn-primary fw-bold text-white font-size-16 text-center">
										{t("Buy Now")}
									</Link>
								</div>
								<div className="d-flex py-3">
									<div className="w-100">
										<button
											style={{
												background: "var(--primary-color)",
												borderColor: "var(--primary-color)",
											}}
											className="w-100 btn br-25 btnCall text-center"
											onClick={() => setCallModal((c) => !c)}>
											<i className="fas fa-phone-alt"></i> {t("call")}
										</button>
									</div>
									<div className="w-100 mx-2">
										<button
											style={{
												background: "var(--primary-color)",
												borderColor: "var(--primary-color)",
											}}
											className="w-100 br-25 btn btnCall text-center"
											onClick={() => setMessageModal((c) => !c)}>
											<i className="fa fa-envelope"></i>
										</button>
									</div>
								</div>
								<div className="d-flex">
									{interestLoading ? (
										<div className="w-100 d-flex justify-content-center pt-2">
											<Spinner size="sm" color="primary" />
										</div>
									) : (
										<div className="w-100">
											<button
												style={{
													background: "var(--primary-color)",
													borderColor: "var(--primary-color)",
												}}
												className="w-100 btn br-25 btnCall text-center"
												onClick={() => {
													interestHandler(resaleDetails.id);
												}}>
												{isInterested() ? (
													<i className="fas fa-heart text-danger"></i>
												) : (
													<i className="far fa-heart text-danger"></i>
												)}
											</button>
										</div>
									)}
									<div className="mx-2 w-100">
										<ReactWhatsapp
											number={
												resaleDetails?.sales_rep?.phone?.includes("+")
													? resaleDetails?.sales_rep?.phone
													: `+2${resaleDetails?.sales_rep?.phone}`
											}
											style={{
												background: "var(--primary-color)",
												borderColor: "var(--primary-color)",
											}}
											class="btn br-25 btnCall text-center w-100"
											message="">
											<img src={whatsapp} alt="whatsapp" width="20" />
										</ReactWhatsapp>
									</div>
								</div>
							</div>
						</Col>
					</Row>
					<div className="mt-5">
						<CardText
							tag="h3"
							className="text-primary font-size-32 bask-font py-2 fw-bold ">
							{t("Description")}
						</CardText>
						<p className="font-size-16 m-0 text-color">
							{resaleDetails?.description[`${AuthData.lang}`]
								? resaleDetails?.description[`${AuthData.lang}`]
								: resaleDetails?.description?.en}
						</p>
					</div>

					<div className="mt-5 mb-5 properties-details">
						<h3 className="text-primary font-size-32 fw-bold mb-3 ">
							{t("Property Amenities")}
						</h3>
						<Row>
							<Col xl={3} lg={3} md={4} xs={12}>
								<div className="mb-3">
									<Media>
										<Media body>
											<p>{t("property type")}</p>
											<h5>
												{resaleDetails?.unit_type?.name[`${AuthData.lang}`]
													? resaleDetails?.unit_type?.name[`${AuthData.lang}`]
													: resaleDetails?.unit_type?.name?.en}
											</h5>
										</Media>
									</Media>
								</div>
							</Col>
							<Col xl={3} lg={3} md={4} xs={12}>
								<div className="mb-3">
									<Media>
										<Media body>
											<p> {t("area")}</p>
											<h5>{resaleDetails?.area?.name}</h5>
										</Media>
									</Media>
								</div>
							</Col>
							{!!resaleDetails?.floor && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("Floor No.")}</p>
												<h5>{resaleDetails?.floor}</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{!!resaleDetails?.total_built_up_area && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("Built Up Area")}</p>
												<h5>
													{parseFloat(
														resaleDetails?.total_built_up_area
													).toFixed(0)}{" "}
													{t("sqm")}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{!!resaleDetails?.bedrooms && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p> {t("No. of Bedrooms")}</p>
												<h5>
													{resaleDetails.bedrooms} {t("Bedrooms")}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{!!resaleDetails?.bathrooms && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p> {t("No. of Bathrooms")}</p>
												<h5>
													{resaleDetails?.bathrooms} {t("Bathrooms")}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{resaleDetails?.finishing_type?.name[`${AuthData.lang}`] && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("finishing")}</p>
												<h5>
													{resaleDetails?.finishing_type?.name[
														`${AuthData.lang}`
													]
														? resaleDetails?.finishing_type?.name[
																`${AuthData.lang}`
														  ]
														: resaleDetails?.finishing_type?.name?.en}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							<Col xl={3} lg={3} md={4} xs={12}>
								<div className="mb-3">
									<Media>
										<Media body>
											<p>{t("payment type")}</p>
											<h5>
												{resaleDetails?.payment_plan?.payment_method ===
												"Owner Installment"
													? t("completion installment with compound")
													: resaleDetails?.payment_plan?.payment_method ===
													  "Cash"
													? t("only cash")
													: t("installment with seller")}
											</h5>
										</Media>
									</Media>
								</div>
							</Col>

							{!!resaleDetails.amenities?.length &&
								resaleDetails?.amenities?.map((amenity, index) => {
									return (
										<Col key={index} xl={3} lg={3} md={4} xs={12}>
											<div className="mb-3">
												<Media>
													<Media body>
														<p>{`Amenity ${index + 1}`}</p>
														<h5>
															{!!amenity?.name[AuthData?.lang]
																? amenity?.name[AuthData?.lang]
																: amenity?.name?.en}
														</h5>
													</Media>
												</Media>
											</div>
										</Col>
									);
								})}
						</Row>
					</div>
					<div className="mt-3">
						<div>
							<h3
								className="text-primary font-size-32 fw-bold mb-2"
								dangerouslySetInnerHTML={{
									__html: t("payment plans title"),
								}}></h3>
							<p className="text-color pb-3 font-size-16">
								{t("payment subtitle")}
							</p>
						</div>
						<Col md={12}>
							{resaleDetails?.payment_plan?.payment_method === "Cash" && (
								<div className="p-4">
									<CardText
										tag="h4"
										className="font-size-20 fw-bold text-muted mx-4 mb-4 mt-2  text-primary">
										{t("only cash")}
									</CardText>
								</div>
							)}

							{resaleDetails?.payment_plan?.payment_method ===
								"Installment" && (
								<Row className="payment-table mb-4">
									<Col md={12}>
										<div
											className="table-responsivep-3"
											style={{
												background: "var(--bg-color)",
												borderRadius: "25px",
											}}>
											<Table responsive className="mb-0">
												<thead>
													<tr>
														<td className="font-size-16 text-color border-0">
															{t("Total Price")}
														</td>
														<td className="font-size-16 text-color border-0">
															{t("Years")}
														</td>
														<td className="font-size-16 text-color border-0">
															{t("Down Payment")}{" "}
														</td>
														<td className="font-size-16 text-color border-0">
															{t("Payment Frequency")}{" "}
														</td>
														<td className="font-size-16 text-color border-0">
															{t("Payment Amount")}{" "}
														</td>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td className="font-size-16 text-primary border-0">
															{toCurrency(
																resaleDetails?.payment_plan?.total_price
															)}{" "}
															{currency?.currency_code}
														</td>
														{resaleDetails?.payment_plan?.years?.map(
															(year, index) => {
																return (
																	<React.Fragment key={index}>
																		<td className="font-size-16  text-primary border-0">
																			{year?.years}
																		</td>
																		<td className="font-size-16  text-primary border-0">
																			{" "}
																			{toCurrency(
																				resaleDetails?.payment_plan?.years[0]
																					?.down_payment
																			)}{" "}
																			{currency?.currency_code}
																		</td>
																		{year?.recurring_payments?.map(
																			(recuring, index) => {
																				return (
																					<React.Fragment key={index}>
																						<td className="font-size-16  text-primary border-0">
																							{recuring?.payment_frequency}
																						</td>
																						<td className="font-size-16  text-primary border-0">
																							{" "}
																							{toCurrency(
																								resaleDetails?.payment_plan
																									?.years[0]
																									?.recurring_payments[0]
																									?.payment_amount
																							)}{" "}
																							{currency?.currency_code}
																						</td>
																					</React.Fragment>
																				);
																			}
																		)}
																	</React.Fragment>
																);
															}
														)}
													</tr>
												</tbody>
											</Table>
										</div>
									</Col>
								</Row>
							)}
							{resaleDetails?.payment_plan?.payment_method ===
								"Owner Installment" && (
								<Row className="my-2 text-primary p-2 d-flex justify-content-center">
									<Row
										className="p-4 mb-4 d-flex justify-content-between"
										style={{
											margin: "0 20%",
											border: "1px solid #556ee6",
											borderRadius: "10px",
										}}>
										<Col md={5}>
											<h2 className="fw-bold font-size-18 text-color">
												{t("Payment Method")} :
											</h2>
											<h4 className="text-primary">
												{t("completion installment with compound")}
											</h4>
										</Col>
										<Col md={3}>
											<button
												className="w-100  h-100 btn fw-bold font-size-16  text-center"
												style={{
													borderRadius: "10px",
													background:
														activeOwnerPay == "1"
															? "var(--primary-color)"
															: "var(--bg-color)",
													color:
														activeOwnerPay == "1"
															? "#FFF"
															: "var(--primary-color)",
												}}
												onClick={() => {
													setActiveOwnerPay("1");
												}}>
												{t("unit installment")}
											</button>
										</Col>
										<Col md={3}>
											<button
												className="w-100 h-100 btn fw-bold font-size-16 text-center"
												style={{
													borderRadius: "10px",
													background:
														activeOwnerPay == "2"
															? "var(--primary-color)"
															: "var(--bg-color)",
													color:
														activeOwnerPay == "2"
															? "#FFF"
															: "var(--primary-color)",
												}}
												onClick={() => {
													setActiveOwnerPay("2");
												}}>
												{t("another payment plan type")}
											</button>
										</Col>
									</Row>
									{activeOwnerPay === "1" ? (
										<Col md={12} className="pt-2">
											<div
												className="table-responsive responsiveTable"
												style={{ dir: AuthData.lang == "ar" ? "rtl" : "ltr" }}>
												<Table>
													<thead>
														<tr>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color  px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Total Price")}
															</th>
															{resaleDetails.payment_plan.owner_installment
																.original_price && (
																<th
																	className={classnames(
																		"p-0 font-size-16 text-color  px-0",
																		{
																			"text-end": AuthData.lang === "ar",
																			"text-start": AuthData.lang !== "ar",
																		}
																	)}>
																	{t("Original Price")}
																</th>
															)}
															<th
																className={classnames(
																	"p-0 font-size-16 text-color  px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Down Payment")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color  px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Payment Amount")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Payment Frequency")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Until Month")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Until Year")}
															</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td
																className={classnames(
																	"font-size-14 text-primary px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{toCurrency(
																	resaleDetails.payment_plan.total_price
																)}{" "}
																{currency?.currency_code}
															</td>
															{resaleDetails.payment_plan.owner_installment
																.original_price && (
																<td
																	className={classnames(
																		"font-size-14 text-primary px-0",
																		{
																			"text-end": AuthData.lang === "ar",
																			"text-start": AuthData.lang !== "ar",
																		}
																	)}>
																	{toCurrency(
																		resaleDetails.payment_plan.owner_installment
																			.original_price
																	)}{" "}
																	{currency?.currency_code}
																</td>
															)}
															<td
																className={classnames(
																	"font-size-14 text-primary px-0",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{toCurrency(
																	resaleDetails.payment_plan.owner_installment
																		.paid_price
																)}{" "}
																{currency?.currency_code}
															</td>
															{resaleDetails?.payment_plan?.owner_installment?.recurring_payments?.map(
																(item, index) => {
																	return (
																		<>
																			<td
																				className={classnames(
																					"font-size-14 px-0",
																					{
																						"text-end": AuthData.lang === "ar",
																						"text-start":
																							AuthData.lang !== "ar",
																					}
																				)}>
																				{!!item?.payment_amount
																					? toCurrency(item?.payment_amount)
																					: "-"}{" "}
																				{!!item?.payment_amount &&
																					currency?.currency_code}
																			</td>
																			<td
																				className={classnames(
																					"font-size-14 px-0",
																					{
																						"text-end": AuthData.lang === "ar",
																						"text-start":
																							AuthData.lang !== "ar",
																					}
																				)}>
																				{!!item.payment_frequency
																					? t(`${item.payment_frequency}`)
																					: "-"}
																			</td>
																		</>
																	);
																}
															)}
															<td
																className={classnames("font-size-14 px-0", {
																	"text-end": AuthData.lang === "ar",
																	"text-start": AuthData.lang !== "ar",
																})}>
																{
																	resaleDetails.payment_plan.owner_installment
																		.until_month
																}
															</td>
															<td
																className={classnames("font-size-14 px-0", {
																	"text-end": AuthData.lang === "ar",
																	"text-start": AuthData.lang !== "ar",
																})}>
																{
																	resaleDetails.payment_plan.owner_installment
																		.until_year
																}
															</td>
														</tr>
													</tbody>
												</Table>
											</div>
										</Col>
									) : (
										<Row className="pt-2">
											<div className="table-responsive responsiveTable">
												<Table>
													<thead>
														<tr>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Payment Name")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Payment Fees")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Payment Frequency")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Start Year")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Start Month")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("End Year")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("End Month")}
															</th>
															<th
																className={classnames(
																	"p-0 font-size-16 text-color ",
																	{
																		"text-end": AuthData.lang === "ar",
																		"text-start": AuthData.lang !== "ar",
																	}
																)}>
																{t("Payment Amount")}
															</th>
														</tr>
													</thead>
													<tbody>
														{resaleDetails?.payment_plan?.owner_installment?.off_payments?.map(
															(item, index) => {
																return (
																	<tr key={index}>
																		<td
																			className={classnames(
																				"font-size-14 text-primary  px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{item.payment_name}
																		</td>
																		<td
																			className={classnames(
																				"font-size-14 text-primary px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{toCurrency(item.payment_fees)}{" "}
																			{currency?.currency_code}
																		</td>
																		<td
																			className={classnames(
																				"font-size-14 text-primary px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{item.payment_frequency}
																		</td>
																		<td
																			className={classnames(
																				"font-size-14 text-primary px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{item.year_number}
																		</td>
																		<td
																			className={classnames(
																				"font-size-14 text-primary px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{item.month_number}
																		</td>
																		<td
																			className={classnames(
																				"font-size-14 text-primary px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{item.end_year}
																		</td>
																		<td
																			className={classnames(
																				"font-size-14 text-primary px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{item.end_month}
																		</td>
																		<td
																			className={classnames(
																				"font-size-14 text-primary px-0",
																				{
																					"text-end": AuthData.lang === "ar",
																					"text-start": AuthData.lang !== "ar",
																				}
																			)}>
																			{toCurrency(item.payment_amount)}{" "}
																			{currency?.currency_code}
																		</td>
																	</tr>
																);
															}
														)}
													</tbody>
												</Table>
											</div>
										</Row>
									)}
								</Row>
							)}
						</Col>
					</div>

					{!!mapRender && (
						<div>
							<p className="bask-font text-primary font-size-32 mb-2">
								{"location"}
							</p>
							<CardBody className="">
								<MyMap
									updateLocationPositions={updateLocationPositions}
									lat={resaleDetails.location.lat}
									lng={resaleDetails.location.lang}
								/>
							</CardBody>
						</div>
					)}
					{!!resaleDetails?.videos?.length &&
						resaleDetails?.videos?.length !== 0 && (
							<div>
								<Carousel
									className="pb-3 mb-4"
									swipeable={true}
									draggable={true}
									showDots={true}
									responsive={videoResponsive}
									infinite={false}
									autoPlaySpeed={1000}
									keyBoardControl={true}
									customTransition="all .5"
									transitionDuration={500}
									customRightArrow={<CustomRight />}
									customLeftArrow={<CustomLeft />}
									containerClass="carousel-container w-100 videos-carousel"
									removeArrowOnDeviceType={[]}
									dotListClass="custom-dot-list-style"
									itemClass="carousel-item-padding-40-px">
									{resaleDetails?.videos?.map((video, index) => {
										return (
											<video key={index} controls>
												<source src={video?.path} type="video/mp4" />
											</video>
										);
									})}
								</Carousel>
							</div>
						)}
				</Container>
			</div>

			<CheckAvailabilityModal
				modal={checkAvailabilityModal}
				setModal={setCheckAvailabilityModal}
			/>
			<CallModal
				modal={callModal}
				setModal={setCallModal}
				phone={resaleDetails?.sales_rep?.phone}
			/>
			<MessageModal
				modal={messageModal}
				setModal={setMessageModal}
				item={resaleDetails}
				type="resale"
			/>
		</div>
	);
};
const CustomRight = ({ onClick }) => (
	<button onClick={onClick} className="arrow right border-0">
		<i className="fas fa-arrow-right fa-1x"></i>
	</button>
);
const CustomLeft = ({ onClick }) => (
	<button onClick={onClick} className="arrow left border-0">
		<i className="fas fa-arrow-left fa-1x"></i>
	</button>
);
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default ResaleDetailsPage;
